import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, MainContext } from '@blaze-cms/nextjs-components';
import buildLinkExtraProps from '../helpers/build-link-extra-props';
const BlazeLink = ({
  children,
  className,
  name,
  ariaLabel,
  href,
  as,
  shallow,
  scroll,
  gtmId,
  onClick
}) => {
  const {
    hasGTM
  } = useContext(MainContext);
  const gtmProps = hasGTM && !!gtmId ? {
    gtmId
  } : {};
  const linkExtraProps = buildLinkExtraProps(_objectSpread({
    className,
    name,
    as
  }, gtmProps));
  if (!href) return children;
  return /*#__PURE__*/React.createElement(Link, _extends({
    href: href,
    ariaLabel: ariaLabel,
    shallow: shallow,
    scroll: scroll,
    onClick: onClick
  }, linkExtraProps), children);
};
BlazeLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  href: PropTypes.string,
  as: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  shallow: PropTypes.bool,
  scroll: PropTypes.bool,
  gtmId: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string
};
BlazeLink.defaultProps = {
  children: [],
  as: '',
  href: '/',
  name: '',
  title: '',
  className: '',
  shallow: false,
  scroll: null,
  gtmId: '',
  onClick: null,
  ariaLabel: ''
};
export default BlazeLink;
//# sourceMappingURL=BlazeLink.js.map